import React from "react";
import CapsuleImageVertical from "../CapsuleImageVertical/CapsuleImageVertical";
import SectionTwoImage from "../../Assets/Images/about-us-section-two-1.png";
import SectionTwoImageMobile from "../../Assets/Images/history-mobile-bg.png";
import AmericaFidImage from "../../Assets/Images/american-fidelity-white-logo.svg";
import AmericaFidRedImage from "../../Assets/Images/american-fidelity-red-logo.svg";
import { useTranslation } from "../../Hooks/useTranslation"; // Import the hook

const History = () => {
  const translations = useTranslation(); // Get translations dynamically
  return (
    <>
      <div className="flex-1">
        <div className="my-12 lg:hidden flex -ml-4">
          <img
            src={SectionTwoImageMobile}
            alt="section-two-image-mobile"
            className="w-full"
          />
        </div>
      </div>

      <div className="flex-1 mt-2 lg:mt-16 max-w-[417px] animate__animated  animate__fadeInLeft  lg:pl-0 px-4 history-tab-content-vs">
        {/* <img
          src={AmericaFidImage}
          className="mb-6 lg:block hidden"
          alt="iambest-logo"
        /> */}
        {/* <img
          src={AmericaFidRedImage}
          className="mb-6 lg:hidden block"
          alt="iambest-logo"
        />
        <p className="text-[14px] font-semibold mb-2 text-justify lg:text-white text-black">
          {translations.historyTitle}
        </p> */}
        <p className="text-[14px] lg:mb-8 text-left lg:text-white text-black extra-para-vs">
          {translations.historyDescription}
        </p>
        {/* <button className="text-[#00363C] font-bold bg-white border text-[14px] border-[#0D4248] border-solid rounded-full text-sm px-5 text-center mb-4 gotofaqbtn hover:bg-[#eeecf3] hidden lg:block">
          Learn more
        </button> */}
      </div>
    </>
  );
};

export default History;
